export default IconLetterUSmall => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-letter-u-small" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M10 8v6a2 2 0 1 0 4 0v-6" />
</svg>`;